module.exports = __webpack_public_path__ + "static/fast-secure-video-poster-300445d7932e33c78c381137cc34f02f.png";